// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Perks/index.css
// module id = 2547
// module chunks = 0